import { initI18n, buildI18nResources } from '@tsl-frontend/tsl-locale';

import { enGBTranslations, enUSTranslations } from './translations';

const resources = buildI18nResources(enGBTranslations, enUSTranslations);
await initI18n(resources);
